import { useState } from "react";
import {
  Container,
  CssBaseline,
  Box,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../hooks/redux-hooks";
import { changePassword } from "../slices/authSlice";
import {
  showNotification,
  NotificationType,
} from "../slices/notificationSlice";
import { useNavigate, Navigate } from "react-router-dom";

const ChangePassword = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const basicUserInfo = useAppSelector((state) => state.auth.basicUserInfo);

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  if (!basicUserInfo) {
    return <Navigate replace to={"/login"} />;
  }

  const handleSubmit = async () => {
    setError("");

    if (!oldPassword || !newPassword || !confirmPassword) {
      setError(t("pleaseInputAllPasswords"));
      return;
    }

    if (newPassword.length < 6) {
      setError(t("passwordTooShort"));
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(t("passwordsNotMatch"));
      return;
    }

    try {
      const result = await dispatch(
        changePassword({
          oldPassword,
          newPassword,
        })
      ).unwrap();

      if (result) {
        dispatch(
          showNotification({
            message: t("passwordChangeSuccess"),
            type: NotificationType.Success,
          })
        );
        navigate(-1);
      }
    } catch (submitError: any) {
      setError(submitError?.message || t("passwordChangeFailed"));
    }
  };

  return (
    <Container maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3 }}>
          {t("menuChangePassword")}
        </Typography>
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="oldPassword"
          label={t("currentPassword")}
          name="oldPassword"
          autoFocus
          value={oldPassword}
          onChange={(event) => setOldPassword(event.target.value)}
          error={!!error}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="newPassword"
          label={t("newPassword")}
          name="newPassword"
          value={newPassword}
          onChange={(event) => setNewPassword(event.target.value)}
          error={!!error}
        />
        <TextField
          margin="normal"
          required
          fullWidth
          type="password"
          id="confirmPassword"
          label={t("confirmPassword")}
          name="confirmPassword"
          value={confirmPassword}
          onChange={(event) => setConfirmPassword(event.target.value)}
          error={!!error}
          helperText={error}
        />
        <Button
          fullWidth
          variant="contained"
          sx={{ mt: 3 }}
          onClick={handleSubmit}
        >
          {t("btnConfirm")}
        </Button>
        <Button
          fullWidth
          variant="outlined"
          sx={{ mt: 2 }}
          onClick={() => navigate(-1)}
        >
          {t("btnBack")}
        </Button>
      </Box>
    </Container>
  );
};

export default ChangePassword;
